import React from "react";
import { useTranslation } from "react-i18next";

const StarRating = ({ value, onChange }) => (
  <div className="flex items-center justify-center mb-4">
    {[1, 2, 3, 4, 5].map((star) => (
      <span
        key={star}
        className={`cursor-pointer text-2xl ${star <= value ? "text-yellow-400" : "text-gray-300"}`}
        onClick={() => onChange(star)}
        role="button"
        aria-label={`Rate ${star} star${star > 1 ? "s" : ""}`}
      >
        ★
      </span>
    ))}
  </div>
);

const GuestReviewModal = ({
  show,
  reviewValue,
  setReviewValue,
  reviewComment,
  setReviewComment,
  onClose,
  onUpdate,
  updating,
}) => {
  const { t } = useTranslation();

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
        <h2 className="text-xl font-bold mb-4">{t("update_review")}</h2>
        <StarRating value={reviewValue} onChange={setReviewValue} />
        <textarea
          className="w-full border rounded p-2 mb-4"
          rows={4}
          value={reviewComment}
          onChange={e => setReviewComment(e.target.value)}
          placeholder={t("add_comment")}
        />
        <div className="flex justify-end gap-2">
          <button
            className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-600"
            onClick={onClose}
            disabled={updating}
          >
            {t("cancel")}
          </button>
          <button
            className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-700"
            onClick={onUpdate}
            disabled={updating || reviewValue === 0}
          >
            {updating ? t("updating") : t("update")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default GuestReviewModal;